import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeModule, TabNavigationModule } from '@com-delta-idp/mnx-ui-kit';
import { OfferActionBannerModule } from '../../features/offer-action-banner/offer-action-banner.module';
import { OfferDetailsBannerModule } from '../../features/offer-details-banner/offer-details-banner.module';
import { OfferCreditBannerModule } from '../../features/offer-credit-banner/offer-credit-banner.module';
import { FastActionBannerPageComponent } from './fast-action-banner-page.component';

@NgModule({
  declarations: [FastActionBannerPageComponent],
  imports: [
    CommonModule,
    TabNavigationModule,
    OfferCreditBannerModule,
    OfferDetailsBannerModule,
    OfferActionBannerModule,
    SafeModule
  ],
  exports: [FastActionBannerPageComponent]
})
export class FastActionBannerPageModule {}
